import React, { useRef, useEffect } from "react"
import styled from "styled-components"
import { motion, AnimatePresence } from "framer-motion"
import { ReactComponent as Arrow } from "../../../assets/icons/logout_arrow.svg"
import { screenSize } from "../../../stylesGlobal/Variables"
import { GoogleLogout } from 'react-google-login';

const ModalWrapper = styled(motion.div)`
    position:fixed;
    z-index:var(--zIndex-high);
    width:100%;
    height:100vh;
    background:transparent;
    display:flex;
    align-items:center;
    justify-content:center;
    transform:translate3d(0px,0px,0px);

    .modal__container{
        position:absolute;
        z-index:var(--zIndex-high);
        width:15%;
        background:var(--color-white);
        display:flex;
        flex-direction:column;
        top:5.4rem;
        right:3rem;
        padding:2.5rem;
        box-shadow: 0px 0 83px 0px #00000029;
        border-radius:.6rem;

        h3{
            font-size:1.6rem;
            font-weight:600;
            margin-bottom:1.5rem;
            color:rgba(0,0,0,.68);
        }

        button{
            background:none;
            border:1px solid transparent;
            font-size:1.6rem;
            font-weight:600;
            color:var(--color-blue);
            display:flex;
            align-items:center;
            cursor:pointer;

            svg{
                width:2.5rem;
                fill:var(--color-blue);
                margin-left:2rem;
            }

            &:focus{
                outline:none;
                border:1px solid var(--color-blue);
            }
            &.no-border{
                &:focus {
                    border: none;
                }
            }
        }
    }

    @media (min-width: ${screenSize.size_m}){
        .modal__container{
            width:12%;
        }
    }
`

type Props = {
    onClose: () => void,
    isOpen: boolean,
    onLogout: () => void
}

const UserModal = (props: Props) => {
    const modalContainerRef = useRef<HTMLElement>()

    useEffect(() => {
        const handleClickOutside = (ev: MouseEvent) => {
            if (modalContainerRef.current && !modalContainerRef.current.contains(ev.target as Node)) {
                props.onClose()
            }
        }
        document.addEventListener("click", handleClickOutside)

        return () => {
            document.removeEventListener("click", handleClickOutside)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalContainerRef])

    return (
        <AnimatePresence>
            {
                props.isOpen && (
                    <ModalWrapper
                        initial={{ opacity: 0, y: -20, }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{
                            duration: 0.2,
                        }}
                    >
                        <motion.section
                            className="modal__container"
                            ref={modalContainerRef}
                        >
                            <h3>Profile</h3>
                            <button className="no-border" onClick={props.onLogout}>
                                <GoogleLogout
                                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                    render={(props) => <p {...props}>Log out</p>}
                                >
                                </GoogleLogout>
                                <Arrow />
                            </button>
                        </motion.section>
                    </ModalWrapper>
                )
            }
        </AnimatePresence>
    )
}

export default UserModal